module.exports = __webpack_public_path__ + "Switches-pana-4e7ab665a58d1dbb6e748cac7da172ab.png";